'use client';
import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';


import Image from '@eliadmin/core/src/components/image/image-wrapped';
import Link from '@eliadmin/core/src/components/link';
import { PreviewVideo } from '../shared/preview-video';

import type { TDynamicData } from '@eliadmin/core/src/api/dynamics/dynamics-api';

import { Button } from '@eliadmin/core/src/components/ui/button';
import { HtmlDescription } from '../shared/html-description';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { Heading } from '../shared/heading';

interface InfoSectionProps {
  id?: string;
  section: TDynamicData;
  reversed?: boolean;
  isFirstSection?: boolean;
  className?: {
    section?: string;
    container?: string;
  };
}

export function InfoSection({
  id,
  section,
  className,
  reversed = false,
  isFirstSection = false,
}: InfoSectionProps) {
  const videoUrl = section?.fields[6]?.file?.url;

  return (
    <section id={id} className={cn('custom-section', 'px-0 sm:px-6', className?.section)}>
      <div
        className={cn(
          'custom-container',
          'flex flex-col items-start justify-start gap-0 lg:items-center lg:justify-between',
          reversed ? 'lg:flex-row-reverse' : 'lg:flex-row',
          className?.container,
        )}
      >
        <div className="relative z-[3] h-[615px] w-full sm:h-[615px] sm:max-w-[400px] lg:h-[620px] xl:h-[629px]">
          {/* <Image
            src={'/images/sign.svg'}
            alt={'Danceana'}
            width={240}
            height={24}
            className={cn(
              'absolute z-[6] hidden object-contain',
              !reversed && 'lg:-right-[120px] lg:top-8 lg:block',
            )}
          /> */}
          <Image
            src={'/images/sign.svg'}
            alt={'Danceana'}
            width={140}
            height={14}
            className="absolute -bottom-1.5 left-6 z-[6] block object-contain lg:hidden"
          />
          {videoUrl ? (
            <PreviewVideo src={videoUrl} poster={section.image?.url}
              sizes="(min-width: 640px) 400px, 100vw"
              overlayClassName="bg-gradient-to-t from-black/40 to-black/5" />
          ) : (
            <>
              <Image
                src={section?.image?.url ?? '/images/placeholder.png'}
                alt={resolveImageAlt(section?.image, section?.name ?? 'Danceana')}
                width={0}
                height={0}
                className="absolute inset-0 z-0 h-full w-full object-cover object-center"
                sizes="(min-width: 610px) 610px, 100vw"
              />
              <div className="absolute inset-0 z-[1] h-full w-full bg-gradient-to-t from-black/40 to-black/5" />
            </>
          )}
        </div>
        <div className="relative z-[2] flex w-full flex-col items-start justify-start gap-6 bg-[#F6F6F6] px-6 py-12 sm:gap-8 sm:px-8 lg:max-w-[840px] lg:px-14 lg:py-14 xl:px-16 xl:py-16">
          <Image
            src={'/images/sign.svg'}
            alt={'Danceana'}
            width={240}
            height={24}
            className={cn(
              'absolute z-[6] hidden object-contain',
              reversed && 'left-1/2 -translate-x-1/2 lg:-top-2 lg:block',
            )}
          />
          <Heading subtitle={section?.fields[1]?.value} title={section?.name} titleAs={isFirstSection ? 'h1' : 'h2'} />
          <HtmlDescription
            content={section?.fields[2]?.value ?? ''}
            size="base"
            className="ea-info-section__description w-full text-black/70"
          />
          <Button asChild variant={'dark'} className="w-full sm:w-fit">
            <Link prefetch={false} prefetchOnHover href={section?.fields[4]?.value ?? '#'}>
              {section?.fields[3]?.value}
            </Link>
          </Button>
        </div>
      </div>
    </section>
  );
}
